module.exports = __webpack_public_path__ + "img/icon-edit-prompt.d32558a5.svg";